var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333313 1.5C0.333313 0.671573 1.00489 0 1.83331 0H2.98168C3.68473 0 4.29345 0.488298 4.44596 1.1746L5.16218 4.39757C5.33436 5.17238 4.87315 5.9472 4.10998 6.16525L3.17719 6.43176C2.76641 6.54913 2.53438 6.98665 2.69728 7.38159C3.86332 10.2087 6.12457 12.47 8.95172 13.636C9.34666 13.7989 9.78419 13.5669 9.90155 13.1561L10.1681 12.2233C10.3861 11.4602 11.1609 10.999 11.9357 11.1711L15.1587 11.8873C15.845 12.0399 16.3333 12.6486 16.3333 13.3516V14.5C16.3333 15.3284 15.6617 16 14.8333 16H13.3333C12.1848 16 11.0699 15.8509 10.0076 15.5705C5.49996 14.3809 1.95239 10.8334 0.762805 6.32576C0.482444 5.26341 0.333313 4.14856 0.333313 3V1.5Z",
    fill: "#062A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPhone);
export default __webpack_public_path__ + "static/media/landing-phone.6a8df2f17ab8d4aaf45cc0eb23ca70cd.svg";
export { ForwardRef as ReactComponent };